import image from '../../api/image'
import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  imageMap: {},
})

// getters
const getters = {
}

// actions
const actions = {
  getImageMap({ commit }) {
    return image.listImages().then(resp => {
      const sortedImageMap = Object.keys(resp).sort((a, b) => b.localeCompare(a)).reduce((r, k) => (r[k] = resp[k], r), {})
      commit('set', ['imageMap', sortedImageMap])
      return true
    })
  },
  deleteImage({ state, commit, }, { key, imageItem }) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteImage(id: $id)
        }
      `,
      variables: {  
        id: imageItem.id,
      },
    }).then(() => {
      commit('removeImage', { key, imageItem, })
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  removeImage (state, { key, imageItem, }) {
    const newImageMap = state.imageMap
    const index = newImageMap[key].indexOf(imageItem)
    if (index > -1) {
      newImageMap[key].splice(index, 1);
      if (newImageMap[key].length === 0) {
        delete newImageMap[key]
      }
    }
    state.imageMap = newImageMap
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}